// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-custom[data-v-68ad32ba]{height:100%;min-height:165px;background-size:50%;background-color:#f5f5f5}.card-custom.no-flip-card[data-v-68ad32ba]:hover,.no-flip-card[data-v-68ad32ba]:hover{transform:none!important;-webkit-transform:none!important;-webkit-box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important;box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important}", ""]);
// Exports
module.exports = exports;
